import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import VueModal from 'vue2-modal'
import { canNavigate, customNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import admin from './routes/admin'
import dashboard from './routes/dashboard'
import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
import chartsMaps from './routes/charts-maps'
import formsTable from './routes/forms-tables'
import others from './routes/others'
import appsettings from "@/store/app-settings";

Vue.use(VueRouter)
Vue.use(VueModal)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'ComplaintMainSearch' } },

    ...apps,
    ...admin,
    ...dashboard,
    ...pages,
    ...chartsMaps,
    ...formsTable,
    ...uiElements,
    ...others,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }
  //customNavigate(to)  

  const userData = getUserData()
  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  console.log("userData", getUserData(), "to", to)
  /// ตรงนี้มาเพิ่มการเช็คสำหรับ กทม เพิ่มเติม
  if (userData && userData.selectUserRole && userData.selectUserRole.value
    && userData.selectUserRole.value.toLowerCase() === appsettings.complaintRoleId.bangkok.toLowerCase()
  ) {
    //console.log("is bangkok user")
    const bangkokRoutes = [
      'BangkokOfficer',
      'BangkokOfficerManage',
      'BangkokOfficerHistory',
      'dashboard-bangkok',
    ];
    if (!bangkokRoutes.includes(to.name)) {
      return next({ name: 'BangkokOfficer' })
    }
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
